import {
  MOCK_ACTIVITY_STATS,
  getMockPointHistoryPage,
} from './mockProfileData';
import apiClient, { getUserInfo, setUserInfo } from '@shared/api/client';
import { ENDPOINTS } from '@shared/api/endpoints';

export async function getMyProfile() {
  const response = await apiClient.get(ENDPOINTS.PROFILE.DESCRIBE);
  // Refresh localStorage userInfo with latest profile data
  if (response) {
    const current = getUserInfo() ?? {};
    setUserInfo({
      ...current,
      name: response.user_name ?? current.name,
      dharmaName: response.dharma_name ?? current.dharmaName,
      monasteryId: response.monastery_id ?? current.monasteryId,
      monasteryName: response.monastery_name ?? current.monasteryName,
      avatar: response.mascot_url ?? current.avatar,
      available_point: response.available_point ?? current.available_point,
    });
    window.dispatchEvent(new Event('auth-change'));
  }
  return response;
}

const AVATAR_CACHE_KEY = 'profile_avatar_url';

export async function getProfileAvatar() {
  try {
    const response = await apiClient.get(ENDPOINTS.PROFILE.DESCRIBE);
    return response?.mascot_url || null;
  } catch {
    return null;
  }
}

export function clearAvatarCache() {
  sessionStorage.removeItem(AVATAR_CACHE_KEY);
}

export async function getPointHistory(page = 1) {
  if (FORCE_MOCK) {
    await new Promise((r) => setTimeout(r, 300));
    return getMockPointHistoryPage(page);
  }
  // TODO: return apiClient.get(ENDPOINTS.PROFILE.POINT_HISTORY, { params: { page } });
}

export async function getActivityList() {
  const response = await apiClient.post(ENDPOINTS.PROFILE.ACTIVITY_LIST, {});
  return response;
}

export async function getLightingPostList() {
  const response = await apiClient.post(ENDPOINTS.PROFILE.LIGHTING_POST_LIST, {});
  return response;
}

export async function getActivityStats() {
  if (FORCE_MOCK) {
    await new Promise((r) => setTimeout(r, 200));
    return MOCK_ACTIVITY_STATS.map((s) => ({ ...s }));
  }
  // TODO: return apiClient.get(ENDPOINTS.PROFILE.ACTIVITY_STATS);
}

export async function getBuddhistList() {
  const response = await apiClient.post(ENDPOINTS.POINT_EX.M10_BUDDHIST_LIST, {});
  return response;
}

export async function getMascotList({ is_collected } = {}) {
  const response = await apiClient.post(ENDPOINTS.POINT_EX.M08_MASCOT_LIST, { ...(is_collected !== undefined && { "is_collected": is_collected }) });
  return response;
}

export async function getVowList() {
  const response = await apiClient.post(ENDPOINTS.POINT_EX.M09_VOW_LIST, {});
  return response;
}

export async function getDnaList() {
  const response = await apiClient.get(ENDPOINTS.PROFILE.DNA_LIST);
  return response;
}

export async function getBoardList(board_id) {
  const response = await apiClient.post(ENDPOINTS.PROFILE.BOARD_LIST, { ...(board_id && { 'board_id': board_id }) });
  return response;
}

export async function getVowDescribe(vowList) {
  const response = await apiClient.post(ENDPOINTS.POINT_EX.VOW005_VOW_DESCRIBE, {
    // page: vowList.page,
    // per_page: vowList.per_page,
    ...(vowList.keyword && { 'keyword': vowList.keyword }),
    content_id: vowList.content_id,
  });
  return response;
}
export async function getPostcardDescribe() {
  const response = await apiClient.get(ENDPOINTS.PROFILE.POSTCARD_DESCRIBE);
  return response;
}
export async function getPostcardList(postcardList) {
  const response = await apiClient.post(ENDPOINTS.PROFILE.POSTCARD_LIST, {
    ...(postcardList.keyword !== undefined && { 'keyword': postcardList.keyword }),
    ...(postcardList.item_ids !== undefined && { 'item_ids': postcardList.item_ids }),
    ...(postcardList.is_scored !== undefined && { 'is_scored': postcardList.is_scored }),
    ...(postcardList.is_viewed !== undefined && { 'is_viewed': postcardList.is_viewed }),
    ...(postcardList.page !== undefined && { 'page': postcardList.page }),
    ...(postcardList.per_page !== undefined && { 'per_page': postcardList.per_page }),
  });
  return response;
}

export async function getPostcardItemCategory() {
  const response = await apiClient.get(ENDPOINTS.PROFILE.POSTCARD_ITEM_CATEGORY);
  return response;
}

export async function getExhibitionVowDescribe() {
  const response = await apiClient.get(ENDPOINTS.PROFILE.EXHIBITION_VOW_DESCRIBE);
  // console.log('EXHIBITION_VOW_DESCRIBE', response);
  return response;
}

export async function getExhibitionVowList(exhibitionVowList = {}) {
  const response = await apiClient.post(ENDPOINTS.PROFILE.EXHIBITION_VOW_LIST, {
    page: exhibitionVowList.page,
    per_page: exhibitionVowList.per_page,
  });
  return response;
}

export async function getPointTxList() {
  const response = await apiClient.post(ENDPOINTS.PROFILE.POINT_TX_LIST, {});
  return response;
}

export async function getShadowList() {
  const response = await apiClient.post(ENDPOINTS.PROFILE.SHADOWS_LIST, {});
  return response;
}

export async function getExhibitionPostList() {
  const response = await apiClient.post(ENDPOINTS.PROFILE.EXHIBITION_POST_LIST, {});
  return response;
}

export async function updateProfileAvatar({ reward_id }) {
  const response = await apiClient.post(ENDPOINTS.PROFILE.UPDATE, { reward_id: reward_id });
  return response;
}

export async function getPhysicalGiftExchangeRuleList() {
  const response = await apiClient.get(ENDPOINTS.PHYSICAL_GIFT.EXCHANGE_RULE_LIST);
  return response;
}

export async function getPhysicalGiftExchangeCode({ rule_id }) {
  const response = await apiClient.post(ENDPOINTS.PHYSICAL_GIFT.EXCHANGE_RULE_GET_CODE, { rule_id });
  return response;
}

export async function getPhysicalGiftRecordResult({ rule_id }) {
  const response = await apiClient.post(ENDPOINTS.PHYSICAL_GIFT.RECORD_RESULT, { rule_id });
  return response;
}
